import { Component, OnInit } from '@angular/core'
import { NetworkService } from './services/network/network.service'
import 'zone.js/plugins/zone-patch-rxjs'
import { PreloadImgComponent } from './shared/preload-img/preload-img.component'
import { IonicModule } from '@ionic/angular'
// import { register } from 'swiper/element/bundle'

// TODO: register() is used for game map coloring image. Uncomment when game-map-image get back or clean up with swiper dependency if game-map-image removed
//register()

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [PreloadImgComponent, IonicModule]
})
export class AppComponent implements OnInit {
  constructor(private networkService: NetworkService) {}

  ngOnInit() {
    this.networkService.checkNetworkStatus()
  }
}
